import { render } from "./faqView.vue?vue&type=template&id=555ef60b&scoped=true&ts=true"
import script from "./faqView.vue?vue&type=script&lang=ts&config=true"
export * from "./faqView.vue?vue&type=script&lang=ts&config=true"

import "./faqView.vue?vue&type=style&index=0&id=555ef60b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-555ef60b"]])

export default __exports__